module.exports = __webpack_public_path__ + "h5/img/character.06f694a5.jpg";